import Image from 'next/image';

import { Box, Text } from '@chakra-ui/react';

import { CaseStudyTestimonial } from '../models/case-study-content';

export function CaseStudyTestimonialCard({ testimonial }: { testimonial: CaseStudyTestimonial }) {
  return (
    <Box
      as='section'
      backgroundColor='accent.sky.100'
      borderColor='accent.sky.500'
      borderRadius='4px 4px 24px 4px'
      borderStyle='solid'
      borderWidth='1px'
      padding={{ base: '24px 16px 24px 16px', md: '48px 56px 48px 48px' }}
    >
      <Text fontSize='24px' lineHeight='27px'>{`"${testimonial.quote}"`}</Text>

      <Box alignItems='center' display='flex' marginTop='40px'>
        <Box borderRadius='64px' marginRight='16px' overflow='hidden'>
          <Image alt='Company Logo' height={64} src={testimonial.profileImage.asset.url} width={64} />
        </Box>

        <Box>
          <Text fontSize='20px' fontStyle='normal' fontWeight='600'>
            {testimonial.name}
          </Text>
          <Text>{testimonial.title}</Text>
        </Box>
      </Box>
    </Box>
  );
}
